import React, { forwardRef } from 'react'
import styled from 'styled-components'


export const StyledComponent = styled.button`
display: flex;
gap: 10px;
align-items: center;

position: fixed;

border: 0;
font-family: ${p => p.theme.fontFamilyBase};

border-radius: 4px;

/* использую width вместо padding, чтобы кнопка не мялась при движении влево - нужна фиксирванная ширина */
/* width: 210px; */
padding: 12px 20px;

transition: transform 0.2s ease;

${p => p.open ? `
background: rgba(255, 255, 255, 1);
` : `
background: rgba(255, 255, 255, 0.5);
`}

box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

cursor: pointer;

font-weight: 600;
font-size: 14px;
line-height: 19.07px;
letter-spacing: 0%;

color: rgba(27, 83, 102, 1);

z-index: 1000;

&:hover {
  background: #FFFFFF;
  transform: scale(1.04);

  border: 0.5px solid transparent; /* Use transparent for border */
  /* Use background-image with linear-gradient and background-clip for border effect */
  background-image: linear-gradient(#FFFFFF, #FFFFFF),
                   linear-gradient(90deg, rgba(0, 174, 239, 0.7) 0%, rgba(0, 100, 137, 0.7) 100%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  /* This ensures the white background only fills the padding area, while the gradient fills the border */
}

& .contact-us-button-icon {
  width: 20px;
  height: 18px;
}

${p => p.isMobile && `
width: 48px;
height: 48px;
padding: 0;
justify-content: center;
gap: 0;
border-radius: 50%;
background: rgba(255, 255, 255, 0.96);
backdrop-filter: blur(8px);
box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.18);

& .contact-us-button-icon {
  width: 22px;
  height: 20px;
}

&:hover {
  transform: none;
}
`}

${p => p.css}
`
const _ContactUs_Button = forwardRef((props, ref) => <StyledComponent {...props} ref={ref} />)
_ContactUs_Button.propTypes = {}
_ContactUs_Button.className = StyledComponent

export default _ContactUs_Button
